// FLOW III

import React from "react"
import PropTypes from "prop-types"
import TradeInResult from "./TradeInResult"
import { trackFunction } from "website_script/lib/iframeTrackingHelper"

const FlowValuationWithoutLeadForm = ({ tradeInResult, carSummaryHtml }) => (
  <div>
    <TradeInResult
      {...tradeInResult}
      carSummaryHtml={carSummaryHtml}
      trackFunction={trackFunction}
    />
  </div>
)

FlowValuationWithoutLeadForm.propTypes = {
  carSummaryHtml: PropTypes.string,
  tradeInResult: PropTypes.object,
}

export default FlowValuationWithoutLeadForm
